module.exports = __webpack_public_path__ + "static/media/chandra_suresh.218243aa.png";